import React from 'react';
import { motion } from 'framer-motion';
import { BarChart, Handshake, Users, ShieldCheck, HeartHandshake, Lightbulb } from 'lucide-react';

const ValuesSection = () => {
  const values = [
    {
      icon: ShieldCheck,
      title: "Trasparenza",
      description: "Comunichiamo con chiarezza ogni aspetto della compravendita, dai costi alle tempistiche, per decisioni consapevoli."
    },
    {
      icon: HeartHandshake,
      title: "Fiducia",
      description: "Costruiamo relazioni durature basate sulla fiducia e sul rispetto reciproco con ogni cliente."
    },
    {
      icon: Handshake,
      title: "Professionalità",
      description: "La nostra formazione continua garantisce un servizio sempre aggiornato e competente."
    },
    {
      icon: Lightbulb,
      title: "Innovazione",
      description: "Utilizziamo strumenti e strategie all'avanguardia per migliorare costantemente il nostro servizio."
    },
    {
      icon: Users,
      title: "Personalizzazione",
      description: "Ascoltiamo attentamente le tue esigenze e i tuoi desideri per indirizzarti verso l'immobile che rispecchia il tuo stile e le tue aspirazioni"
    },
    {
      icon: BarChart,
      title: "Risultati",
      description: "Ci impegniamo a ottenere il miglior risultato possibile per ogni cliente, misurando il successo con la soddisfazione."
    }
  ];
  
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-secondary uppercase tracking-wider font-semibold">I Nostri Valori</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2 mb-4">Cosa Ci Distingue</h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            I nostri valori non sono solo parole, ma principi che guidano ogni nostra azione quotidiana
            nell'assistere i nostri clienti nella compravendita immobiliare.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all"
            >
              <div className="rounded-full bg-primary/10 w-16 h-16 flex items-center justify-center mb-6">
                <value.icon className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-4 text-primary">{value.title}</h3>
              <p className="text-gray-600">{value.description}</p>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-16 bg-primary rounded-xl overflow-hidden shadow-xl"
        >
          <div className="grid md:grid-cols-2 items-center">
            <div className="p-10 text-white">
              <h3 className="text-3xl font-monomakh mb-6">La Nostra Visione</h3>
              <p className="text-gray-200 mb-6 text-lg leading-relaxed">
                Crediamo che trovare la casa giusta sia un diritto, non un privilegio. 
                La nostra visione è costruire ponti tra le persone e le loro case dei sogni, 
                rendendo il processo semplice, trasparente e gratificante.
              </p>
              <p className="text-gray-200 text-lg leading-relaxed">
                Non vendiamo semplici muri, ma spazi dove custodire ricordi, 
                crescere una famiglia e dare vita ai progetti più importanti.
              </p>
            </div>
            <div className="hidden md:block h-full">
              <img 
                src="/images/home2.jpeg" 
                alt="Famiglia felice nella nuova casa"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ValuesSection